<template>
    <div>
        <template v-if="isBusy">
            <Preloader />
        </template>

        <template v-else>
            <GarantieHeader title="Garantie Camping Car" />
            <GarantieStepper :currentStep="currentStep" :steps="steps" @update:currentStep="handleStepChange" />

            <form method="POST" name="devis_panne_mecanique_camping_car" @submit.prevent="onSubmit">
                <input type="hidden" name="category" value="1">
                <div class="row">
                    <div class="col-12 form-card-container">
                        <div class="form-card">
                            <!-- STEP 1 -->
                            <template v-if="currentStep === 1">
                                <div class="row m-0 align-items-center">
                                    <div
                                        :class="(isVehicleSearching || searchVehicleFilled) ? 'col-lg-7 pr-lg-4' : 'col-lg-12'">
                                        <div class="form-card-header">
                                            <h2 class="form-card-title">Informations sur le véhicule à assurer</h2>
                                            <span class="required-notice">(* champs obligatoires)</span>
                                        </div>

                                        <!-- Step 1 - Field 1: Registration -->
                                        <div class="form-row-grid mb-0">
                                            <div class="form-group">
                                                <label class="form-label">Immatriculation <span class="required"
                                                        v-if="!isNewCar">*</span></label>
                                                <div class="form-input-container">
                                                    <div class="registration-search-wrapper">
                                                        <input type="text" v-model="garantieCampingCar.immatriculation"
                                                            placeholder="Ex: AF-785-HT" maxlength="10"
                                                            @input="handleImmatriculationInput($event)"
                                                            @keydown.enter.prevent="searchByRegNumberImmediately"
                                                            class="redesign-input registration-input-field"
                                                            :class="{ 'input-error': hasError('immatriculation') }" />
                                                    </div>
                                                    <div v-if="hasError('immatriculation')" class="error-message">
                                                        {{ getError('immatriculation') }}
                                                    </div>
                                                </div>
                                                <div v-if="showManualEntryLink || !garantieCampingCar.immatriculation"
                                                    class="registration-help camping-car-text">
                                                    <a @click="showManualEntryPopup = true" class="manual-entry-link">
                                                        Je ne connais pas mon immatriculation
                                                    </a>
                                                </div>
                                                <div v-else-if="isManualEntry" class="registration-help">
                                                    <a @click="showManualEntryPopup = true" class="manual-entry-link">
                                                        Modifier les informations du véhicule
                                                    </a>
                                                </div>
                                            </div>
                                            <div class="form-group" v-if="!(isVehicleSearching || searchVehicleFilled)">
                                            </div>
                                        </div>

                                        <!-- Step 1 - Field 2: Details Grid -->
                                        <div class="form-row-grid">
                                            <div class="form-group">
                                                <label class="form-label">Kilométrage <span
                                                        class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.km_reel"
                                                        class="redesign-input" placeholder="Ex: 50000"
                                                        @input="handleKmInput($event)"
                                                        :class="{ 'input-error': hasError('km_reel') }" />
                                                    <div v-if="hasError('km_reel')" class="error-message">
                                                        {{ getError('km_reel') }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="form-label">Date d'effet <span
                                                        class="required">*</span></label>
                                                <div
                                                    class="form-input-container date-input-container currency-datepicker">
                                                    <CustomDatepicker :date.sync="effectiveDateInput"
                                                        :disableDate="true" :has-error="hasError('effective_date')"
                                                        class="redesign-datepicker" />
                                                    <div v-if="hasError('effective_date')" class="error-message">
                                                        {{ getError('effective_date') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Step 1 - Field 3: Mixed Toggle Row -->
                                        <div class="form-row-grid">
                                            <div class="form-group" v-if="!is_LeMondeCampingCar">
                                                <label class="form-label">Camping car neuf <span
                                                        class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <div class="redesign-option-group toggle-switch">
                                                        <button type="button" class="option-btn"
                                                            :class="{ 'active': garantieCampingCar.is_new === 'Oui', 'option-btn-error': hasError('is_new') }"
                                                            @click="garantieCampingCar.is_new = 'Oui'">
                                                            Oui
                                                        </button>
                                                        <button type="button" class="option-btn"
                                                            :class="{ 'active': garantieCampingCar.is_new === 'Non', 'option-btn-error': hasError('is_new') }"
                                                            @click="garantieCampingCar.is_new = 'Non'">
                                                            Non
                                                        </button>
                                                    </div>
                                                    <div v-if="hasError('is_new')" class="error-message">
                                                        {{ getError('is_new') }}
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="form-label">Financement <span
                                                        class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <div class="redesign-option-group toggle-switch">
                                                        <button type="button" class="option-btn"
                                                            :class="{ 'active': garantieCampingCar.finance == 1, 'option-btn-error': hasError('finance') }"
                                                            @click="garantieCampingCar.finance = 1">
                                                            Oui
                                                        </button>
                                                        <button type="button" class="option-btn"
                                                            :class="{ 'active': garantieCampingCar.finance == 0, 'option-btn-error': hasError('finance') }"
                                                            @click="garantieCampingCar.finance = 0">
                                                            Non
                                                        </button>
                                                    </div>
                                                    <div v-if="hasError('finance')" class="error-message">
                                                        {{ getError('finance') }}
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Added automatically on right if enabled -->
                                            <div class="form-group" v-if="garantieCampingCar.finance == 1">
                                                <label class="form-label">Organisme de financement <span
                                                        class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.finance_name"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('finance_name') }" />
                                                    <div v-if="hasError('finance_name')" class="error-message">
                                                        {{ getError('finance_name') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <!-- Hidden Technical Fields (populated via API or Manual Entry Modal) -->
                                        <div style="display: none;">
                                            <input type="hidden" v-model="garantieCampingCar.marque_porteur" />
                                            <input type="hidden" v-model="garantieCampingCar.modele_porteur" />
                                            <input type="hidden" v-model="garantieCampingCar.puis_fisc" />
                                            <input type="hidden" v-model="garantieCampingCar.num_serie" />
                                            <select v-model="garantieCampingCar.ptc">
                                                <option v-for="option in ptcOptions" :key="option.value"
                                                    :value="option.value">
                                                    {{ option.name }}</option>
                                            </select>
                                            <CustomDatepicker :date.sync="circulationDateInput" />
                                        </div>
                                    </div>
                                    <!-- Vehicle Summary Card -->
                                    <div class="col-lg-5" v-if="isVehicleSearching || searchVehicleFilled">
                                        <div v-if="isVehicleSearching" class="vehicle-search-loader">
                                            <Preloader wrapperHeight="250px" />
                                        </div>
                                        <VehicleSummaryCard v-else :details="vehicleSummary" />
                                    </div>
                                </div>

                                <div class="form-card-footer-nav justify-content-center align-items-center">
                                    <div class="eligibility-action-wrapper">
                                        <button type="button" class="btn-primary-outline"
                                            :class="{ 'disabled': (isVehicleTooOld && !isManualEntry) || !searchVehicleFilled }"
                                            :disabled="(isVehicleTooOld && !isManualEntry) || !searchVehicleFilled"
                                            @click="goToNextStep">
                                            Suivant
                                        </button>

                                        <div v-if="isVehicleTooOld" class="eligibility-info-trigger"
                                            title="Véhicule non éligible : voir instructions">
                                            <font-awesome-icon icon="info-circle" />
                                            <div class="eligibility-popover">
                                                <div class="popover-title">
                                                    <font-awesome-icon icon="exclamation-triangle" />
                                                    Informations sur l'éligibilité
                                                </div>
                                                <p class="popover-desc">Les critères du véhicule ne permettent pas de
                                                    souscrire à la garantie choisie.</p>
                                                <p class="popover-desc">
                                                    Pour effectuer une demande de dérogation, veuillez adresser le
                                                    contrôle technique à :
                                                    <a
                                                        href="mailto:servicetechnique@dynassurances.fr">servicetechnique@dynassurances.fr</a>
                                                </p>
                                                <div class="popover-desc mb-1">Informations requises :</div>
                                                <ul class="popover-list">
                                                    <li>Immatriculation du véhicule</li>
                                                    <li>Votre code garage</li>
                                                </ul>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </template>

                            <!-- STEP 2 -->
                            <template v-else-if="currentStep === 2">
                                <div class="form-card-header">
                                    <h2 class="form-card-title">Information sur la garantie</h2>
                                    <span class="required-notice">(* champs obligatoires)</span>
                                </div>

                                <div class="form-row-grid">
                                    <label class="form-label col-3">Choisissez une durée <span
                                            class="required">*</span></label>
                                    <div class="redesign-option-group highlighted-options col-8 pr-2">
                                        <button v-for="item in durationOptions" :key="item.value" type="button"
                                            class="option-btn"
                                            :class="{ 'active': garantieCampingCar.duree == item.value, 'option-btn-error': hasError('duree') }"
                                            @click="garantieCampingCar.duree = item.value">
                                            {{ item.name }}
                                        </button>
                                    </div>
                                    <div v-if="hasError('duree')" class="error-message">{{ getError('duree') }}
                                    </div>
                                </div>

                                <div class="form-row-grid mt-4">
                                    <label class="form-label col-3">Assistance souhaitée <span
                                            class="required">*</span></label>
                                    <div class="redesign-option-group highlighted-options col-6">
                                        <button type="button" class="option-btn"
                                            :class="{ 'active': garantieCampingCar.assistance == 0, 'option-btn-error': hasError('assistance') }"
                                            @click="garantieCampingCar.assistance = 0">
                                            Pack Assistance
                                        </button>
                                        <button type="button" class="option-btn"
                                            :class="{ 'active': garantieCampingCar.assistance == 1, 'option-btn-error': hasError('assistance') }"
                                            @click="garantieCampingCar.assistance = 1">
                                            Sans pack assistance
                                        </button>
                                    </div>
                                    <button type="button" @click="showAssistanceDetails()"
                                        class="btn btn-outline-primary border-radius-10 col-2">
                                        Voir détails
                                    </button>
                                    <div v-if="hasError('assistance')" class="error-message">{{
                                        getError('assistance') }}</div>
                                </div>


                                <!-- Plans Section -->
                                <InsurancePlansCarousel :apiUrl="'/camping-car/calculate'" :plans="availablePlans"
                                    :selectedPlanId="garantieCampingCar.garantie" :duration="garantieCampingCar.duree"
                                    :vehicle="garantieCampingCar"
                                    @select-plan="(id, price) => { garantieCampingCar.garantie = id; selectedPlanPrice = price; }"
                                    @go-to-step="currentStep = $event" />

                                <div class="form-card-footer-nav">
                                    <button type="button" class="btn-secondary-outline" @click="currentStep--">
                                        Retour
                                    </button>
                                    <button type="button" class="btn-primary-outline" @click="goToNextStep">
                                        Suivant
                                    </button>
                                </div>
                            </template>

                            <!-- STEP 3 -->
                            <template v-else-if="currentStep === 3">
                                <div class="form-card-header">
                                    <h2 class="form-card-title">Informations sur le propriétaire du Camping-car</h2>
                                    <span class="required-notice">(* champs obligatoires)</span>
                                </div>

                                <div class="row step-3-row">
                                    <div class="col-12 col-lg-8 col-xl-8 pr-xl-4">
                                        <div class="form-row-grid">
                                            <div class="form-group flex-width-sm">
                                                <label class="form-label">Civilité</label>
                                                <div class="form-input-container">
                                                    <select v-model="garantieCampingCar.civilite"
                                                        class="redesign-select">
                                                        <option value="0">M</option>
                                                        <option value="1">Mlle</option>
                                                        <option value="2">Mme</option>
                                                        <option value="3">Société</option>
                                                        <option value="4">Mr et Mme</option>
                                                    </select>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="form-label">
                                                    {{ garantieCampingCar.civilite == 3 ? 'Prénom du signataire' :
                                                        'Prénom' }}
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.prenom"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('prenom') }" />
                                                    <div v-if="hasError('prenom')" class="error-message">{{
                                                        getError('prenom')
                                                        }}</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="form-label">
                                                    {{ garantieCampingCar.civilite == 3 ? 'Nom du signataire' : 'Nom' }}
                                                    <span class="required">*</span>
                                                </label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.nom"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('nom') }" />
                                                    <div v-if="hasError('nom')" class="error-message">{{
                                                        getError('nom') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <template v-if="garantieCampingCar.civilite == 3">
                                            <div class="form-row-grid">
                                                <div class="form-group full-width">
                                                    <label class="form-label">Société <span
                                                            class="required">*</span></label>
                                                    <div class="form-input-container">
                                                        <input type="text"
                                                            v-model="garantieCampingCar.name_of_signatory"
                                                            class="redesign-input"
                                                            :class="{ 'input-error': hasError('name_of_signatory') }" />
                                                        <div v-if="hasError('name_of_signatory')" class="error-message">
                                                            {{
                                                                getError('name_of_signatory') }}</div>
                                                    </div>
                                                </div>
                                            </div>
                                        </template>

                                        <div class="form-row-grid">
                                            <div class="form-group full-width">
                                                <label class="form-label">Adresse <span
                                                        class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.adresse"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('adresse') }" />
                                                    <div v-if="hasError('adresse')" class="error-message">{{
                                                        getError('adresse')
                                                    }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-row-grid">
                                            <div class="form-group">
                                                <label class="form-label">Code postal <span
                                                        class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.cp" maxlength="5"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('cp') }" />
                                                    <div v-if="hasError('cp')" class="error-message">{{ getError('cp')
                                                    }}</div>
                                                </div>
                                            </div>

                                            <div class="form-group">
                                                <label class="form-label">Ville <span class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.ville"
                                                        class="redesign-select"
                                                        :class="{ 'input-error': hasError('ville') }" />
                                                    <div v-if="hasError('ville')" class="error-message">{{
                                                        getError('ville') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-row-grid">
                                            <div class="form-group">
                                                <label class="form-label">Téléphone</label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.tel" maxlength="10"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('tel') }" />
                                                    <div v-if="hasError('tel')" class="error-message">{{ getError('tel')
                                                        }}
                                                    </div>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <label class="form-label">Email <span class="required">*</span></label>
                                                <div class="form-input-container">
                                                    <input type="email" v-model="garantieCampingCar.email"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('email') }" />
                                                    <div v-if="hasError('email')" class="error-message">{{
                                                        getError('email') }}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                        <div class="form-group">
                                            <label class="form-label">Fax</label>
                                            <div class="form-input-container">
                                                <input type="text" v-model="garantieCampingCar.fax" maxlength="10"
                                                    class="redesign-input"
                                                    :class="{ 'input-error': hasError('fax') }" />
                                            </div>
                                        </div>

                                        <div v-if="mechanicClientPayment">
                                            <!-- <div class="form-group full-width">
                                                <label class="form-label">Les coordonnées de votre compte <span
                                                        class="text-muted">(Exemple :
                                                        FR7630006000011234567890189)</span></label>
                                                <div class="form-input-container">
                                                    <input type="text" v-model="garantieCampingCar.iban"
                                                        class="redesign-input"
                                                        :class="{ 'input-error': hasError('iban') }" />
                                                    <div v-if="hasError('iban')" class="error-message">{{
                                                        getError('iban') }}
                                                    </div>
                                                </div>
                                            </div> -->
                                            <div class="form-group full-width">
                                                <label class="form-label">Date de naissance</label>
                                                <div
                                                    class="form-input-container date-input-container currency-datepicker">
                                                    <CustomDatepicker :date.sync="birthDateInput" :birthdate="true"
                                                        :has-error="hasError('date_of_birth')"
                                                        class="redesign-datepicker" />
                                                    <div v-if="hasError('date_of_birth')" class="error-message">{{
                                                        getError('date_of_birth') }}</div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>

                                    <!-- Summary Column -->
                                    <div class="col-12 col-lg-4 col-xl-4">
                                        <SelectedPlanSummary :plan="{
                                            name: selectedPlanObject ? selectedPlanObject.name : '',
                                            price: selectedPlanPrice || (selectedPlanObject ? selectedPlanObject.basePrice : 0),
                                            key: selectedPlanObject ? selectedPlanObject.key : ''
                                        }" :duration="selectedDurationName" :features="selectedPlanDetailedFeatures"
                                            :vehicle="vehicleSummary"
                                            :termsUrl="selectedPlanObject ? getUrl(selectedPlanObject) : ''" />
                                    </div>

                                    <div class="form-card-footer-nav col-12">
                                        <button type="button" class="btn-secondary-outline" @click="currentStep--">
                                            Retour
                                        </button>
                                        <button type="submit" class="btn-primary-outline">
                                            VOIR LE DEVIS
                                        </button>
                                    </div>
                                </div>
                            </template>

                            <!-- STEP 4 -->
                            <template v-if="currentStep === 4 || currentStep === 5">
                                <GarantieCampingCarView @change-step="goToNextStep" :current-step="currentStep"
                                    :custom-class="'p-0 m-0 bg-transparent'" :insurance-data="savedQuote" />
                                <div class="form-card-footer-nav" v-if="currentStep == 4">
                                    <button type="button" class="btn-secondary-outline" @click="modifyForm()">
                                        Retour
                                    </button>

                                </div>
                            </template>
                        </div>
                    </div>
                </div>

            </form>

            <ManualVehicleEntryModal :is-visible="showManualEntryPopup" :initial-data="garantieCampingCar"
                category="camping-car" @close="showManualEntryPopup = false" @submit="handleManualEntrySubmit" />
        </template>
    </div>
</template>


<script>
import garantieFieldsLists from "@/mixins/garantieFieldsLists";
import Preloader from "@/components/Preloader";
import { DEBOUNCE } from "@/mixins/helper";
import { TheMask } from "vue-the-mask";
import CustomDatepicker from "@/components/CustomInputs/CustomDatepicker";
import InsurancePlansCarousel from "@/components/Garantie/shared/InsurancePlansCarousel";
import SelectedPlanSummary from "@/components/Garantie/shared/SelectedPlanSummary";
import GarantieHeader from "@/components/Garantie/shared/GarantieHeader";
import GarantieStepper from "@/components/Garantie/shared/GarantieStepper";
import { CAMPINGCAR_WARRANTY_DETAILS, getWarrantyFeatures } from "@/constants/warrantyDetails";
import ManualVehicleEntryModal from "@/components/Garantie/shared/ManualVehicleEntryModal";
import manualVehicleEntry from "@/mixins/manualVehicleEntry";
import VehicleSummaryCard from "@/components/Garantie/shared/VehicleSummaryCard";
import GarantieCampingCarView from "@/components/Garantie/camping-car/GarantieCampingCarView";

const INITIAL_FIELDS_VALUES = Object.freeze({
    civilite: 0,
    nom: '',
    prenom: '',
    name_of_signatory: '',
    adresse: '',
    cp: '',
    ville: '',
    tel: '',
    fax: '',
    email: '',
    iban: '',
    // jour_naissance: 1,
    // mois_naissance: 1,
    // annee_naissance: new Date().getFullYear(),
    situation_famille: 0,
    profession: 0,
    is_new: 'Non',
    code_garage: '',
    garantie: 0,
    duree: 0,
    immatriculation: '',
    immatriculation_ancien_numero: '',
    marque_porteur: '',
    modele_porteur: '',
    // marque_cellule: '',
    // modele_cellule: '',
    jour_mise_en_circulation: '',
    mois_mise_en_circulation: '',
    annee_mise_en_circulation: '',
    num_serie: '',
    puis_fisc: '',
    jour_prise_effet: '',
    mois_prise_effet: '',
    annee_prise_effet: '',
    jour_vente: 1,
    mois_vente: 1,
    annee_vente: new Date().getFullYear(),
    jour_livraison: 1,
    mois_livraison: 1,
    annee_livraison: new Date().getFullYear(),
    km_reel: 0,
    assistance: 1,
    finance: 0,
    finance_name: '',
    ptc: 0,
    jour_naissance: '',
    mois_naissance: '',
    annee_naissance: '',
    id_client: null,
});

export default {
    name: 'GarantieCampingCar',
    components: { Preloader, TheMask, CustomDatepicker, InsurancePlansCarousel, SelectedPlanSummary, GarantieHeader, GarantieStepper, ManualVehicleEntryModal, VehicleSummaryCard, GarantieCampingCarView },
    mixins: [garantieFieldsLists, manualVehicleEntry],
    data() {
        return {
            steps: [
                {
                    text: 'INFOS VÉHICULE',
                    icon: `<svg viewBox="0 0 32 32" width="16" height="16" xmlns="http://www.w3.org/2000/svg" fill="currentColor"><g id="SVGRepo_bgCarrier" stroke-width="0"></g><g id="SVGRepo_tracerCarrier" stroke-linecap="round" stroke-linejoin="round"></g><g id="SVGRepo_iconCarrier"> <title></title> <g> <path d="M1,14v9a1,1,0,0,0,1,1H5a3,3,0,0,1,6,0h5V14Z" style="fill: #ffffff"></path> <rect height="10" style="fill: #ffffff" width="5" x="22" y="14"></rect> </g> <circle cx="8" cy="24" r="3" style="fill: none;stroke: #2b2b2b;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2px"></circle> <polyline points="12 24 31 24 31 21" style="fill: none;stroke: #2b2b2b;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.1px"></polyline> <path d="M4,24H2a1,1,0,0,1-1-1V8A3,3,0,0,1,4,5H24a3,3,0,0,1,3,3V23" style="fill: none;stroke: #2b2b2b;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.1px"></path> <path d="M22,21V11a1,1,0,0,0-1-1H17a1,1,0,0,0-1,1V23" style="fill: none;stroke: #2b2b2b;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.1px"></path> <line style="fill: none;stroke: #2b2b2b;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.1px" x1="2" x2="15" y1="14" y2="14"></line> <line style="fill: none;stroke: #2b2b2b;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.1px" x1="23" x2="26" y1="14" y2="14"></line> <path d="M5,13V10A1,1,0,0,1,6,9h4a1,1,0,0,1,1,1v3" style="fill: none;stroke: #2b2b2b;stroke-linecap: round;stroke-linejoin: round;stroke-width: 2.1px"></path> </g></svg>`
                },
                {
                    text: 'OFFRE SÉLECTIONNÉE',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-currency-euro" viewBox="0 0 16 16">
                            <path d="M4 9.42h1.063C5.4 12.323 7.317 14 10.34 14c.622 0 1.167-.068 1.659-.185v-1.3c-.484.119-1.045.17-1.659.17-2.1 0-3.455-1.198-3.775-3.264h4.017v-.928H6.497v-.936q-.002-.165.008-.329h4.078v-.927H6.618c.388-1.898 1.719-2.985 3.723-2.985.614 0 1.175.05 1.659.177V2.194A6.6 6.6 0 0 0 10.341 2c-2.928 0-4.82 1.569-5.244 4.3H4v.928h1.01v1.265H4v.928z"></path>
                        </svg>`
                },
                {
                    text: 'PROPRIÉTAIRE VÉHICULE',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-person-fill" viewBox="0 0 16 16">  <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6"/></svg>`
                },
                {
                    text: 'SOUSCRIPTION',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-pencil-square" viewBox="0 0 16 16"><path d="M15.502 1.94a.5.5 0 0 1 0 .706L14.459 3.69l-2-2L13.502.646a.5.5 0 0 1 .707 0l1.293 1.293zm-1.75 2.456-2-2L4.939 9.21a.5.5 0 0 0-.121.196l-.805 2.414a.25.25 0 0 0 .316.316l2.414-.805a.5.5 0 0 0 .196-.12l6.813-6.814z"/><path fill-rule="evenodd" d="M1 13.5A1.5 1.5 0 0 0 2.5 15h11a1.5 1.5 0 0 0 1.5-1.5v-6a.5.5 0 0 0-1 0v6a.5.5 0 0 1-.5.5h-11a.5.5 0 0 1-.5-.5v-11a.5.5 0 0 1 .5-.5H9a.5.5 0 0 0 0-1H2.5A1.5 1.5 0 0 0 1 2.5v11z"/></svg>`
                },
                {
                    text: 'DOCUMENTS GARANTIE',
                    icon: `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-shield-check" viewBox="0 0 16 16">  <path d="M5.338 1.59a61 61 0 0 0-2.837.856.48.48 0 0 0-.328.39c-.554 4.157.726 7.19 2.253 9.188a10.7 10.7 0 0 0 2.287 2.233c.346.244.652.42.893.533q.18.085.293.118a1 1 0 0 0 .101.025 1 1 0 0 0 .1-.025q.114-.034.294-.118c.24-.113.547-.29.893-.533a10.7 10.7 0 0 0 2.287-2.233c1.527-1.997 2.807-5.031 2.253-9.188a.48.48 0 0 0-.328-.39c-.651-.213-1.75-.56-2.837-.855C9.552 1.29 8.531 1.067 8 1.067c-.53 0-1.552.223-2.662.524zM5.072.56C6.157.265 7.31 0 8 0s1.843.265 2.928.56c1.11.3 2.229.655 2.887.87a1.54 1.54 0 0 1 1.044 1.262c.596 4.477-.787 7.795-2.465 9.99a11.8 11.8 0 0 1-2.517 2.453 7 7 0 0 1-1.048.625c-.28.132-.581.24-.829.24s-.548-.108-.829-.24a7 7 0 0 1-1.048-.625 11.8 11.8 0 0 1-2.517-2.453C1.928 10.487.545 7.169 1.141 2.692A1.54 1.54 0 0 1 2.185 1.43 63 63 0 0 1 5.072.56"/>  <path d="M10.854 5.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 7.793l2.646-2.647a.5.5 0 0 1 .708 0"/></svg>`
                }
            ],
            currentStep: 1,
            garantieCampingCar: {
                ...INITIAL_FIELDS_VALUES,
                duree: 2
            },
            plans: [
                {
                    id: 1,
                    name: 'RÉSEAU',
                    url: '/generate-pdf-terms-conditions/camping-car/reseau',
                    basePrice: 249
                },
                {
                    id: 2,
                    name: 'MAXI RÉSEAU',
                    url: '/generate-pdf-terms-conditions/camping-car/maxi-reseau',
                    basePrice: 349
                },
                {
                    id: 3,
                    name: 'MAXI PLUS',
                    url: '/generate-pdf-terms-conditions/camping-car/maxi-plus',
                    basePrice: 449
                }
            ],
            errors: {},
            isSending: false,
            isBusy: false,
            showManualEntryLink: false,
            showManualEntryPopup: false,
            searchResult: null,
            searchVehicleResult: null,
            searchVehicleFilled: false,
            isMaxiPlusEnabled: true,
            isMaxiPlusEnabledByCirculation: true,
            isVehicleSearching: false,
            isClientSearching: false,
            effectiveDateInput: this.moment().toDate(),
            circulationDateInput: null,
            selectedPlanPrice: 0,
            birthDateInput: '',
            savedQuote: null,
            initialImmatriculation: '',
        }
    },
    computed: {
        isEditCampingCar() {
            return this.$route.params.id || (this.savedQuote && this.savedQuote.id) ? true : false
        },
        existingCustomerFound() {
            return !!this.searchResult;
        },
        existingVehicleFound() {
            return !!this.searchVehicleResult;
        },
        isNewCar() {
            return this.garantieCampingCar.is_new === 'Oui';
        },
        isMaxiPlus() {
            return +this.garantieCampingCar.garantie === 3;
        },
        ptcOptions() {
            return [
                { value: '0', name: 'Chosir un PTC...' },
                { value: '1', name: 'Inférieur ou égal à 3,5 T' },
                { value: '2', name: 'Supérieur à 3,5 T mais inférieur ou égal à 5 T' },
                { value: '3', name: 'Supérieur à 5 T' },
            ];
        },
        is_LeMondeCampingCar() {
            if (this.$store.getters.isLeMondeCampingCar)
                return true;
            else
                return false;
        },
        mechanicClientPayment() {
            let client_payment =
                this.$store.state.userInfo && this.$store.state.userInfo.mechanic
                    ? this.$store.state.userInfo.mechanic.client_payment
                    : null;
            return client_payment ? client_payment : "";
        },
        insuranceTypeOptions() {
            return [
                { name: 'RÉSEAU', value: 1 },
                { name: 'MAXI RÉSEAU', value: 2 },
                { name: 'MAXI PLUS', value: 3 }
            ];
        },
        durationOptions() {
            let options = [
                { name: '6 Mois', value: 1 },
                { name: '12 Mois', value: 2 },
                { name: '24 Mois', value: 3 },
                { name: '36 Mois', value: 4 },
                { name: '48 Mois', value: 5 }
            ];

            if (this.garantieCampingCar.is_new === 'Non') {
                this.garantieCampingCar.duree = 2;
                return options.filter(opt => opt.value !== 5);
            }

            return options;
        },
        availablePlans() {
            const age = this.vehicleAge;

            return this.insuranceTypeOptions.map(opt => {
                const plan = this.plans.find(p => p.id === opt.value);
                if (!plan) return null;
                const detailedFeatures = getWarrantyFeatures({
                    type: plan.id,
                    engine: 0,
                    age: age,
                    category: 'CAMPING-CAR'
                });

                return {
                    ...plan,
                    detailedFeatures
                };
            }).filter(p => !!p);
        },
        selectedPlanObject() {
            if (!this.garantieCampingCar.garantie) return null;
            return this.availablePlans.find(plan => plan.id == this.garantieCampingCar.garantie);
        },
        selectedDurationName() {
            if (!this.garantieCampingCar.duree) return '';
            const opt = this.durationOptions.find(o => o.value == this.garantieCampingCar.duree);
            return opt ? opt.name : '';
        },
        selectedPlanDetailedFeatures() {
            const planId = this.garantieCampingCar.garantie;
            if (!planId) return [];

            const age = this.vehicleAge;

            const features = getWarrantyFeatures({
                type: planId,
                age: age,
                category: 'CAMPING-CAR'
            });

            return features.filter(f => (f.title.toLowerCase() !== 'important' && f.title.toLowerCase() !== 'import'));
        },
        vehicleAge() {
            if (!this.circulationDateInput) return 0;
            const dateMec = this.moment(this.circulationDateInput);
            const today = this.moment();
            return today.diff(dateMec, 'years');
        },
        vehicleSummary() {
            let details = [];

            if (this.garantieCampingCar.immatriculation) {
                details.push({ label: 'Immatriculation', value: this.garantieCampingCar.immatriculation });
            }

            if (this.garantieCampingCar.marque_porteur) {
                details.push({ label: 'Marque', value: this.garantieCampingCar.marque_porteur });
            }

            if (this.garantieCampingCar.modele_porteur) {
                details.push({ label: 'Modèle', value: this.garantieCampingCar.modele_porteur });
            }

            if (this.garantieCampingCar.puis_fisc) {
                details.push({ label: 'Puissance fiscale', value: this.garantieCampingCar.puis_fisc + ' CV' });
            }

            if (this.garantieCampingCar.ptc) {
                details.push({ label: 'PTC', value: (this.ptcOptions.find(o => o.value == this.garantieCampingCar.ptc) || {}).name });
            }

            if (this.garantieCampingCar.km_reel) {
                details.push({ label: 'Kilométrage', value: this.garantieCampingCar.km_reel + ' km' });
            }

            if (this.circulationDateInput) {
                details.push({
                    label: 'Date de circulation',
                    value: this.moment(this.circulationDateInput).format('DD/MM/YYYY')
                });
            }

            if (this.garantieCampingCar.num_serie) {
                details.push({ label: 'Numéro de série', value: this.garantieCampingCar.num_serie });
            }

            return details;
        },
        isVehicleTooOld() {
            return false;
            // if (!this.circulationDateInput) return false;
            // const dateMec = this.moment(this.circulationDateInput);
            // const today = this.moment();
            // const age = today.diff(dateMec, 'years');
            // return age > 14;
        }
    },
    watch: {
        'garantieCampingCar.immatriculation'(val) { if (val) this.clearError('immatriculation'); },
        'garantieCampingCar.is_new': function (val) {
            if (val) this.clearError('is_new');
            let optionsList = this.durationOptions.map(o => o.value);
            if (!optionsList.includes(this.garantieCampingCar.duree)) this.garantieCampingCar.duree = 0;
            this.isMaxiPlusGarantieEnabled();
        },
        'garantieCampingCar.garantie': function (val) {
            if (+val !== 0) this.clearError('garantie');
            if (!this.isNewCar) {
                let optionsList = this.durationOptions.map(o => o.value);
                if (!optionsList.includes(this.garantieCampingCar.duree)) this.garantieCampingCar.duree = 0;
            }
        },
        'garantieCampingCar.km_reel': function (val) {
            if (val) this.clearError('km_reel');
            if (!this.isNewCar) {
                this.isMaxiPlusEnabled = (+val <= 120000);
            }
            else {
                this.isMaxiPlusEnabled = (+val <= 40000);
            }
        },
        'circulationDateInput': function (val) {
            this.isMaxiPlusGarantieEnabled();
        },
        is_LeMondeCampingCar: {
            immediate: true,
            handler(newVal) {
                if (newVal) {
                    this.garantieCampingCar.is_new = 'Non';
                }
            }
        },
        'garantieCampingCar.duree'(val) { if (+val !== 0) this.clearError('duree'); },
        'garantieCampingCar.nom'(val) { if (val) this.clearError('nom'); },
        'garantieCampingCar.prenom'(val) { if (val) this.clearError('prenom'); },
        'garantieCampingCar.adresse'(val) { if (val) this.clearError('adresse'); },
        'garantieCampingCar.cp'(val) { if (val) this.clearError('cp'); },
        'garantieCampingCar.ville'(val) { if (val) this.clearError('ville'); },
        'garantieCampingCar.tel'(val) { if (val) this.clearError('tel'); },
        'garantieCampingCar.email'(val) { if (val) this.clearError('email'); },
        'garantieCampingCar.name_of_signatory'(val) { if (val) this.clearError('name_of_signatory'); },
        effectiveDateInput(val) { if (val) this.clearError('effective_date'); },
        birthDateInput(val) { if (val) this.clearError('date_of_birth'); },
        'garantieCampingCar.finance'(val) { this.clearError('finance'); },
        'garantieCampingCar.assistance'(val) { this.clearError('assistance'); },
        'garantieCampingCar.ptc'(val) { if (+val !== 0) this.clearError('ptc'); },
        'garantieCampingCar.finance_name'(val) { if (val) this.clearError('finance_name'); }
    },
    methods: {
        getUrl(plan) {
            let apiUrl = this.$store.state.baseUrl;
            return apiUrl + plan.url;
        },
        handleImmatriculationInput(event) {
            this.garantieCampingCar.immatriculation = this.formatImmatriculation(this.garantieCampingCar.immatriculation, event);

            // Only trigger search if the value has actually changed from the initial value
            if (this.garantieCampingCar.immatriculation !== this.initialImmatriculation) {
                this.resetVehicleData();
                this.searchByRegNumber();
            }

            this.clearError('immatriculation');
        },
        modifyForm() {
            this.currentStep--;
        },
        resetVehicleData() {
            this.garantieCampingCar.marque_porteur = "";
            this.garantieCampingCar.modele_porteur = "";
            this.garantieCampingCar.num_serie = "";
            this.garantieCampingCar.puis_fisc = "";
            this.garantieCampingCar.ptc = 0;
            this.circulationDateInput = null;
            this.searchVehicleFilled = false;
            this.searchVehicleResult = null;
            this.showManualEntryLink = false;
        },
        searchByRegNumber: DEBOUNCE(function (val) {
            this.executeVehicleSearch();
        }, 500),
        searchByRegNumberImmediately() {
            if (this.garantieCampingCar.immatriculation && this.garantieCampingCar.immatriculation.length >= 7) {
                this.searchByRegNumber.cancel();
                this.executeVehicleSearch();
            }
        },
        executeVehicleSearch() {
            this.garantieCampingCar.immatriculation = this.garantieCampingCar.immatriculation.toUpperCase();

            let matched = this.garantieCampingCar.immatriculation.match(/(^([0-9]{2,}-[A-Z]{2,}-[0-9]{2,})+$)|(^([A-Z]{2,}-[0-9]{2,}-[A-Z]{2,})+$)|(^([0-9]{3}-[A-Z]{3}-[0-9]{2})+$)/g);

            if (matched) {
                let url = 'client/registration',
                    data = {
                        regNumber: this.garantieCampingCar.immatriculation,
                        ccar: true
                    };
                this.isVehicleSearching = true;
                this.apiPost(url, data, false)
                    .then(response => {
                        if (response.data.info) {
                            this.searchVehicleResult = response.data.info;
                            this.isManualEntry = false;
                            this.parseVehicleInfo(this.searchVehicleResult);
                            this.searchVehicleFilled = true;
                            this.showManualEntryLink = false;
                        } else {
                            this.showManualEntryLink = true;
                            this.searchVehicleResult = null;
                        }

                        this.isVehicleSearching = false;
                    })
                    .catch(error => {
                        this.isVehicleSearching = false;

                        if (error.response && error.response.status === 422) {
                            let errorMessage = '';
                            if (error.response.data && error.response.data.errors && error.response.data.errors.regNumber && error.response.data.errors.regNumber[0]) {
                                errorMessage = error.response.data.errors.regNumber[0];
                            } else if (error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            }

                            if (errorMessage) {
                                if (!this.errors.errors) {
                                    this.$set(this.errors, 'errors', {});
                                }
                                this.$set(this.errors.errors, 'immatriculation', [errorMessage]);
                                this.showManualEntryLink = false;
                                this.searchVehicleResult = null;
                                if (typeof this.searchVehicleFilled !== 'undefined') {
                                    this.searchVehicleFilled = false;
                                }
                                return;
                            }
                        }

                        this.showErrorNotification(error);
                        this.showManualEntryLink = true;
                    });
            } else {
                this.showManualEntryLink = false;
            }
        },
        handleKmInput(event) {
            const val = event.target.value.replace(/\D/g, "");
            this.garantieCampingCar.km_reel = val ? parseInt(val, 10) : 0;
            this.clearError('km_reel');
        },
        formatImmatriculation(value, event) {
            const isDeleting = event && (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward');
            const cleanValue = (value || "")
                .toUpperCase()
                .replace(/[^A-Z0-9]/g, "");

            if (!cleanValue) {
                return "";
            }

            const isNumericStart = /^[0-9]/.test(cleanValue);
            const chunkPattern = isNumericStart ? [3, 3, 2] : [2, 3, 2];

            let formatted = "";
            let currentIdx = 0;

            for (let i = 0; i < chunkPattern.length; i++) {
                const chunkSize = chunkPattern[i];
                const chunk = cleanValue.substr(currentIdx, chunkSize);

                if (chunk) {
                    formatted += (formatted ? "-" : "") + chunk;
                }

                currentIdx += chunkSize;
                if (currentIdx >= cleanValue.length) break;
            }

            if (isDeleting && value.endsWith('-')) {
                return value.slice(0, -1);
            }

            return formatted;
        },
        fillTheFieldsByImmatriculation() {
            if (this.searchVehicleResult) {
                this.parseVehicleInfo(this.searchVehicleResult);
                this.searchVehicleFilled = true;
                // this.searchVehicleResult = null;
            }
        },
        parseVehicleInfo(info) {
            // console.log('parseVehicleInfo | info', info);
            /* Car brand */
            if (info.Marque) {
                this.garantieCampingCar.marque_porteur = info.Marque.toLocaleString();
                // this.garantieCampingCar.marque_cellule = info.Marque.toLocaleString();
            }

            /* Modele */
            this.garantieCampingCar.modele_porteur = info.Modele ? info.Modele.toLocaleString() : null;
            // this.garantieCampingCar.modele_cellule = info.Modele ? info.Modele.toLocaleString() : null;
            /* Num serie */
            this.garantieCampingCar.num_serie = info.VIN ? info.VIN : null;

            if (info.PuissFisc) {
                this.garantieCampingCar.puis_fisc = +info.PuissFisc;
            }

            if (info.DateMec) {
                this.circulationDateInput = new Date(info.DateMec);
                let date = this.moment(this.circulationDateInput).format('YYYY-MM-DD');
                let minimumDate = (!this.isNewCar) ? this.moment().subtract(10, 'years').format('YYYY-MM-DD') : this.moment().subtract(24, 'months').format('YYYY-MM-DD');
                let circulationBase = new Date(date).getTime();
                let circulationMinimum = new Date(minimumDate).getTime();
                //more than 2 years for NEW, more than 8 years for OLD
                if (circulationMinimum > circulationBase) {
                    if (this.isNewCar) {
                        this.isMaxiPlusEnabledByCirculation = false;
                    }
                    else {
                        this.isMaxiPlusEnabledByCirculation = true;
                    }
                }
                else {
                    this.isMaxiPlusEnabledByCirculation = true;
                }
            }
            if (info.PTR) {
                if (+info.PTR <= 3500) {
                    this.garantieCampingCar.ptc = 1;
                }
                else if ((+info.PTR >= 3501) && (+info.PTR <= 5000)) {
                    this.garantieCampingCar.ptc = 2;
                }
                else if (+info.PTR >= 5001) {
                    this.garantieCampingCar.ptc = 3;
                }
            }
        },
        searchClient: DEBOUNCE(function (val) {

            if (this.garantieCampingCar.tel.length > 2) {
                let url = 'client/searchOne',
                    data = {
                        tel: this.garantieCampingCar.tel
                    };
                this.isClientSearching = true;
                this.apiGet(url, data, false)
                    .then(response => {
                        if (response.data.client) {
                            this.searchResult = response.data.client;
                            this.parseClientInfo(this.searchResult);
                            this.searchResult = null;
                        }

                        this.isClientSearching = false;
                    })
                    .catch(error => {
                        this.showErrorNotification(error);
                        this.isClientSearching = false;
                    })
            }
        }, 1000),
        fillTheFields() {
            if (this.searchResult) {
                this.parseClientInfo(this.searchResult);
                this.searchResult = null;
            }
        },
        serializeData() {
            return this.garantieCampingCar;
        },
        onSubmit(event) {
            if (!this.validateStep(3)) return;

            this.garantieCampingCar.immatriculation = (this.garantieCampingCar.immatriculation) ? this.garantieCampingCar.immatriculation.toUpperCase() : "";
            this.validateEffectiveDate();
            this.validateCirculationDate();
            // this.validateBirstdayDate();
            this.validateBirthDate();
            this.isSending = true;
            let url = 'garantie/camping_car',
                data = this.serializeData();
            if (this.isEditCampingCar) {
                let quoteId = this.$route.params.id || (this.savedQuote ? this.savedQuote.id : null);
                url = 'garantie/camping_car/' + quoteId + '/edit';
            }
            if (this.is_LeMondeCampingCar) {
                this.garantieCampingCar.is_new = 'Non';
                this.garantieCampingCar.garantie = 8;
            }
            this.apiPostFormData(url, data).then((response) => {
                this.isSending = false;
                this.errors = {};
                if (response.data.calcQuotes)
                    this.$store.dispatch('updateCalcGaranties', response.data.calcQuotes);
                this.showSuccessNotification(response.data.message, '');

                if (response.data.quote) {
                    this.savedQuote = response.data.quote;
                }

                this.currentStep++;
            }).catch(error => {
                this.isSending = false;

                const errorData = error.response.data || {};
                const status = error.response.status;

                this.errors = errorData;

                // Handle 422 error
                if (status === 422) {
                    this.showErrorNotification(
                        "Les données du formulaire sont invalides. Veuillez vérifier toutes les étapes."
                    );
                    return;
                }

                // Default error message
                if (errorData.message) {
                    this.showErrorNotification(errorData.message);
                } else {
                    this.showErrorNotification("Une erreur est survenue.");
                }

                // Specific exception
                if (
                    errorData.exception === "App\\Exceptions\\PriceErrorException"
                ) {
                    this.errors.errors = {
                        error: [errorData.message],
                    };
                }
            })
        },
        getGuarantyInfo() {
            let url = 'garantie/' + this.$route.params.id;
            this.apiGet(url).then(response => {
                this.garantieCampingCar = this.parseQuoteData(response.data.quote)
                this.isBusy = false;
            }).catch(error => {
                console.log(error);
                this.isBusy = false;
            })
        },
        parseClientInfo(client) {
            this.garantieCampingCar.civilite = client.civility;
            this.garantieCampingCar.nom = client.last_name;
            this.garantieCampingCar.prenom = client.first_name;
            this.garantieCampingCar.name_of_signatory = client.name_of_signatory;
            this.garantieCampingCar.adresse = client.address;
            this.garantieCampingCar.cp = client.zip;
            this.garantieCampingCar.ville = client.city;
            this.garantieCampingCar.tel = client.tel;
            this.garantieCampingCar.email = client.email;
            this.garantieCampingCar.iban = client.iban;
            this.garantieCampingCar.fax = client.fax;
            this.garantieCampingCar.id_client = client.id;
            if (client.birthday && client.birthday != '1900-01-01 00:00:00') {
                let birth_day = parseInt(client.birthday.split('-')[2]),
                    birth_month = parseInt(client.birthday.split('-')[1]) - 1,
                    birth_year = parseInt(client.birthday.split('-')[0]);

                this.garantieCampingCar.jour_de_naissance = +birth_day;
                this.garantieCampingCar.mois_de_naissance = +birth_month;
                this.garantieCampingCar.annee_de_naissance = +birth_year;

                this.birthDateInput = new Date(birth_year, birth_month, birth_day);
            }
        },
        handleManualEntrySubmit(data) {
            if (data.immatriculation) {
                let url = "client/registration";
                let reqData = { regNumber: data.immatriculation, ccar: true };
                this.isVehicleSearching = true;
                this.apiPost(url, reqData, false)
                    .then(() => {
                        this.isVehicleSearching = false;
                        this.handleManualEntrySubmitGeneric(data, 'garantieCampingCar');
                    })
                    .catch(error => {
                        this.isVehicleSearching = false;
                        if (error.response && error.response.status === 422) {
                            let errorMessage = '';
                            if (error.response.data && error.response.data.errors && error.response.data.errors.regNumber && error.response.data.errors.regNumber[0]) {
                                errorMessage = error.response.data.errors.regNumber[0];
                            } else if (error.response.data && error.response.data.message) {
                                errorMessage = error.response.data.message;
                            }

                            if (errorMessage) {
                                this.showManualEntryPopup = false;
                                this.garantieCampingCar.immatriculation = data.immatriculation;
                                if (!this.errors.errors) {
                                    this.$set(this.errors, 'errors', {});
                                }
                                this.$set(this.errors.errors, 'immatriculation', [errorMessage]);
                                this.showManualEntryLink = false;
                                this.searchVehicleResult = null;
                                this.searchVehicleFilled = false;
                                return;
                            }
                        }
                        this.handleManualEntrySubmitGeneric(data, 'garantieCampingCar');
                    });
            } else {
                this.handleManualEntrySubmitGeneric(data, 'garantieCampingCar');
            }
        },
        parseQuoteData(quote) {
            let parsedQuote = {};

            parsedQuote.finance = quote.finance || 0;
            parsedQuote.finance_name = quote.finance_name || '';

            if (quote.client && quote.client.id) {
                parsedQuote.civilite = quote.client.civility;
                parsedQuote.nom = quote.client.last_name;
                parsedQuote.prenom = quote.client.first_name;
                parsedQuote.adresse = quote.client.address;
                parsedQuote.cp = quote.client.zip;
                parsedQuote.ville = quote.client.city;
                parsedQuote.tel = quote.client.tel;
                parsedQuote.email = quote.client.email;
                parsedQuote.id_client = quote.client.id;
                parsedQuote.fax = quote.client.fax;
                parsedQuote.iban = quote.client.iban;
                parsedQuote.situation_famille = quote.client.family;
                parsedQuote.profession = quote.client.profession;

                // if(quote.client.datesParse) {
                //     parsedQuote.jour_naissance = quote.client.datesParse.day_birth;
                //     parsedQuote.mois_naissance = quote.client.datesParse.month_birth;
                //     parsedQuote.annee_naissance = quote.client.datesParse.year_birth;
                //
                //     this.birstdayDateInput = this.$root.normalizeDate(quote.client.datesParse.day_birth) + this.$root.normalizeDate(quote.client.datesParse.month_birth) + quote.client.datesParse.year_birth;
                // }
            }

            if (quote.details) {
                parsedQuote.is_new = quote.details.is_new;
                parsedQuote.ptc = quote.details.ptc;
                parsedQuote.code_garage = quote.details.code_garage;
                parsedQuote.garantie = quote.details.garantie;
                parsedQuote.duree = quote.details.duration;
                parsedQuote.immatriculation = quote.details.registration;
                parsedQuote.immatriculation_ancien_numero = quote.details.registration_old_number;
                parsedQuote.marque_porteur = quote.details.marque_porteur;
                parsedQuote.modele_porteur = quote.details.modele_porteur;
                // parsedQuote.marque_cellule = quote.details.marque_cellule;
                // parsedQuote.modele_cellule = quote.details.modele_cellule;

                parsedQuote.jour_mise_en_circulation = quote.details.day_circulation;
                parsedQuote.mois_mise_en_circulation = quote.details.month_circulation;
                parsedQuote.annee_mise_en_circulation = quote.details.year_circulation;

                if (quote.details.day_circulation && quote.details.month_circulation && quote.details.year_circulation) {
                    this.circulationDateInput = new Date(
                        quote.details.year_circulation,
                        quote.details.month_circulation - 1,
                        quote.details.day_circulation,
                    );
                }

                parsedQuote.num_serie = quote.details.serial_number;
                parsedQuote.puis_fisc = quote.details.fiscal_power;

                if (quote.details.datesParse) {
                    let effective_day = quote.details.datesParse.day_effective,
                        effective_month = quote.details.datesParse.month_effective - 1,
                        effective_year = quote.details.datesParse.year_effective;
                    parsedQuote.jour_prise_effet = effective_day;
                    parsedQuote.mois_prise_effet = effective_month;
                    parsedQuote.annee_prise_effet = effective_year;

                    this.effectiveDateInput = new Date(effective_year, effective_month, effective_day);

                    parsedQuote.jour_vente = quote.details.datesParse.day_sale;
                    parsedQuote.mois_vente = quote.details.datesParse.month_sale;
                    parsedQuote.annee_vente = quote.details.datesParse.year_sale;

                    parsedQuote.jour_livraison = quote.details.datesParse.day_delivery;
                    parsedQuote.mois_livraison = quote.details.datesParse.month_delivery;
                    parsedQuote.annee_livraison = quote.details.datesParse.year_delivery;
                }


                parsedQuote.km_reel = quote.details.km_real;
                parsedQuote.assistance = quote.details.assistance;
            }

            this.searchVehicleFilled = true;

            // Store initial immatriculation to avoid redundant API calls on load
            if (parsedQuote.immatriculation) {
                this.initialImmatriculation = parsedQuote.immatriculation;
            }

            return parsedQuote;
        },
        validateEffectiveDate() {
            if (!this.effectiveDateInput) return false;
            let date = this.moment(this.effectiveDateInput);

            this.garantieCampingCar.jour_prise_effet = date.format('D');
            this.garantieCampingCar.mois_prise_effet = date.format('M');
            this.garantieCampingCar.annee_prise_effet = date.format('YYYY');

            return true;
        },
        resetEffectiveDate() {
            this.garantieCampingCar.jour_prise_effet = 1;
            this.garantieCampingCar.mois_prise_effet = 1;
            this.garantieCampingCar.annee_prise_effet = 1970;
        },
        cleanEffectiveDate() {
            this.garantieCampingCar.jour_prise_effet = '';
            this.garantieCampingCar.mois_prise_effet = '';
            this.garantieCampingCar.annee_prise_effet = '';
        },
        validateCirculationDate() {
            if (!this.circulationDateInput) return false;
            let date = this.moment(this.circulationDateInput);

            this.garantieCampingCar.jour_mise_en_circulation = date.format('D');
            this.garantieCampingCar.mois_mise_en_circulation = date.format('M');
            this.garantieCampingCar.annee_mise_en_circulation = date.format('YYYY');

            return true;
        },
        resetCirculationDate() {
            this.garantieCampingCar.jour_mise_en_circulation = '';
            this.garantieCampingCar.mois_mise_en_circulation = '';
            this.garantieCampingCar.annee_mise_en_circulation = '';
        },
        validateBirthDate() {
            if (!this.birthDateInput) return false;
            let date = this.moment(this.birthDateInput);

            this.garantieCampingCar.jour_de_naissance = date.format('D');
            this.garantieCampingCar.mois_de_naissance = date.format('M');
            this.garantieCampingCar.annee_de_naissance = date.format('YYYY');

            return true;
        },
        resetBirthDate() {
            this.garantieCampingCar.jour_de_naissance = 1;
            this.garantieCampingCar.mois_de_naissance = 1;
            this.garantieCampingCar.annee_de_naissance = 1970;
        },
        cleanBirthDate() {
            this.garantieCampingCar.jour_de_naissance = '';
            this.garantieCampingCar.mois_de_naissance = '';
            this.garantieCampingCar.annee_de_naissance = '';
        },
        showAssistanceDetails() {
            let win = window.open('https://assur-camping-car.fr/particulier/produits-assistance-particuliers/pack-assistance-particuliers/', '_blank');
            win.focus();
        },
        hasError(field) {
            return !!(this.errors.errors && this.errors.errors[field]);
        },
        clearError(field) {
            if (this.errors.errors && this.errors.errors[field]) {
                delete this.errors.errors[field];
                this.errors = { ...this.errors };
            }
        },
        getError(field) {
            if (this.errors.errors && this.errors.errors[field]) {
                return this.errors.errors[field][0];
            }
            return null;
        },
        isValidEmail(email) {
            const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
            return re.test(String(email).toLowerCase());
        },
        isMaxiPlusGarantieEnabled() {
            let date = this.moment(this.circulationDateInput).format('YYYY-MM-DD');
            let minimumDate = (!this.isNewCar) ? this.moment().subtract(10, 'years').format('YYYY-MM-DD') : this.moment().subtract(24, 'months').format('YYYY-MM-DD');
            // console.log(`circulationDateInput| this.isNewCar => ${this.isNewCar} | minimumDate => ${minimumDate} | fromDateInput => ${date}`);
            let circulationDateFromInput = new Date(date).getTime();
            let circulationMinimum = new Date(minimumDate).getTime();
            //more than 2 years for NEW, more than 8 years for OLD
            if (circulationMinimum > circulationDateFromInput) {
                this.isMaxiPlusEnabledByCirculation = false;
            }
            else {
                this.isMaxiPlusEnabledByCirculation = true;
            }
            // console.log(`this.isMaxiPlusEnabledByCirculation [checker] => ${this.isMaxiPlusEnabledByCirculation}, this.isNewCar => ${this.isNewCar}`);
        },
        validateStep(step) {
            this.errors = { errors: {} };
            let isValid = true;

            if (step === 1) {
                if (!this.garantieCampingCar.is_new) this.$set(this.errors.errors, 'is_new', ['Sélectionnez si le camping-car est neuf ou non.']);
                if (!this.isManualEntry && !this.garantieCampingCar.immatriculation) this.$set(this.errors.errors, 'immatriculation', ['Immatriculation requise.']);
                if (!this.garantieCampingCar.km_reel) this.$set(this.errors.errors, 'km_reel', ['Kilométrage requis.']);
                if (this.isVehicleTooOld && !this.isManualEntry) this.$set(this.errors.errors, 'eligibility', ["Les critères du véhicule ne permettent pas de souscrire à la garantie choisie."]);
                if (!this.effectiveDateInput) {
                    this.$set(this.errors.errors, 'effective_date', ['Date d\'effet requise.']);
                } else {
                    this.validateEffectiveDate();
                    if (this.circulationDateInput) this.validateCirculationDate();
                }
                if (this.garantieCampingCar.finance && !this.garantieCampingCar.finance_name) {
                    this.$set(this.errors.errors, 'finance_name', ['Finance name required.']);
                }
            } else if (step === 2) {
                if (!this.garantieCampingCar.garantie || this.garantieCampingCar.garantie == 0) this.$set(this.errors.errors, 'garantie', ['Garantie requise.']);
                if (!this.garantieCampingCar.duree || this.garantieCampingCar.duree == 0) this.$set(this.errors.errors, 'duree', ['Durée requise.']);
            } else if (step === 3) {
                if (!this.garantieCampingCar.nom) this.$set(this.errors.errors, 'nom', ['Nom requis.']);
                if (!this.garantieCampingCar.prenom) this.$set(this.errors.errors, 'prenom', ['Prénom requis.']);
                if (!this.garantieCampingCar.adresse) this.$set(this.errors.errors, 'adresse', ['Adresse requise.']);
                if (!this.garantieCampingCar.cp) this.$set(this.errors.errors, 'cp', ['Code postal requis.']);
                if (!this.garantieCampingCar.ville) this.$set(this.errors.errors, 'ville', ['Ville requise.']);
                if (!this.garantieCampingCar.email) {
                    this.$set(this.errors.errors, 'email', ['Email requis.']);
                } else if (!this.isValidEmail(this.garantieCampingCar.email)) {
                    this.$set(this.errors.errors, 'email', ["Format d'email invalide."]);
                }
                if (this.garantieCampingCar.civilite == 3 && !this.garantieCampingCar.name_of_signatory) {
                    this.$set(this.errors.errors, 'name_of_signatory', ['Nom de la société requis.']);
                }
                this.validateBirthDate();
                this.validateEffectiveDate();
                if (this.circulationDateInput) this.validateCirculationDate();
            }

            if (Object.keys(this.errors.errors).length > 0) {
                isValid = false;
                this.$notify({
                    group: "info",
                    type: "warn",
                    title: "Validation",
                    text: "Veuillez remplir les champs obligatoires."
                });
            }

            return isValid;
        },
        handleStepChange(newStep) {
            if (newStep < this.currentStep) {
                this.currentStep = newStep;
            } else if (newStep > this.currentStep) {
                if (newStep === this.currentStep + 1) {
                    this.goToNextStep();
                    if (this.currentStep == 2) {
                        this.validateEffectiveDate();
                        this.validateCirculationDate();
                    }
                }
            }
        },
        goToNextStep() {
            if (this.validateStep(this.currentStep)) {
                this.currentStep++;
            }
        }
    },
    beforeRouteLeave(to, from, next) {
        if (to.params.id && this.savedQuote && to.params.id == this.savedQuote.id) {
            next();
            return;
        }
        this.garantieCampingCar = JSON.parse(JSON.stringify(INITIAL_FIELDS_VALUES));
        this.currentStep = 1;
        next();
    },
    mounted() {
        if (this.$route.params.id) {
            this.isBusy = true;
            this.getGuarantyInfo();
        }
    }
}
</script>



// WEBPACK FOOTER //
// src/components/Garantie/camping-car/GarantieCampingCar.vue